var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "GetStartedLayout",
    {
      attrs: {
        errors: _vm.errors,
        title: `Hi ${_vm.guest.first_name}!`,
        subtitle: `Recommended for ${_vm.child?.first_name ?? "you"}`,
        fluid: "",
        guest: _vm.guest,
        child: _vm.child,
        breadcrumbs: _vm.breadcrumbs,
        review: _vm.review,
        location: _vm.guest.location,
      },
      scopedSlots: _vm._u([
        {
          key: "toggleFilter",
          fn: function () {
            return [
              _c(
                "v-btn",
                {
                  staticClass: "soli-round",
                  attrs: { outlined: "", small: "", color: "white" },
                  on: {
                    click: function ($event) {
                      _vm.showAll = !_vm.showAll
                    },
                  },
                },
                [
                  _vm._v(_vm._s(_vm.showAll ? "All" : "Recommended")),
                  _vm.$vuetify.breakpoint.width > 400
                    ? _c("v-icon", { attrs: { right: "" } }, [
                        _vm._v("filter_list"),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm._l(_vm.getProgramCards, function (card) {
        return _c(
          "v-col",
          {
            key: card.title,
            staticClass: "flex justify-center",
            staticStyle: { "min-width": "336px", "max-width": "378px" },
            attrs: { cols: "12", sm: "8", md: "4", lg: "3" },
          },
          [
            _c("v-hover", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ hover }) {
                      return [
                        _c(
                          "v-card",
                          {
                            staticClass: "soli-round",
                            class: {
                              "on-hover": hover,
                              "mx-3": _vm.$vuetify.breakpoint.smAndUp,
                              "mx-auto": _vm.$vuetify.breakpoint.xs,
                              notRecommended: !card.recommended,
                            },
                            staticStyle: { border: "none" },
                            attrs: {
                              hover: "",
                              light: "",
                              elevation: hover ? 12 : 2,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.proceed(card)
                              },
                            },
                          },
                          [
                            _c(
                              "v-img",
                              {
                                staticClass: "align-end",
                                attrs: {
                                  height: "300",
                                  src: card.src,
                                  "lazy-src": card.lazy,
                                  gradient:
                                    "to bottom, rgb(255 255 255 / 0%), rgba(25, 73, 114, .75)",
                                },
                              },
                              [
                                _c(
                                  "v-card-title",
                                  {
                                    staticClass:
                                      "white--text font-weight-bold text-h5",
                                  },
                                  [_vm._v(_vm._s(card.title))]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-card-actions",
                              { staticClass: "flex justify-end ma-2" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "soli-round",
                                    attrs: {
                                      text: "",
                                      small: "",
                                      color: "dark",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.help(card)
                                      },
                                    },
                                  },
                                  [_vm._v("How It Works")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "soli-round px-2",
                                    attrs: { outlined: "", color: "primary" },
                                  },
                                  [_vm._v("Book Now")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.showHelp
        ? _c("SoliResponsiveDialog", {
            attrs: { fullscreen: "", bottomSheetOnly: "" },
            on: {
              reset: function ($event) {
                _vm.closeModal(() => (_vm.showHelp = false))
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(_vm.showHelp.comp, {
                        tag: "component",
                        attrs: { location: _vm.guest.location },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3842607564
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showProgramInquiry
        ? _c("ShortContactForm", {
            ref: "shortContactForm",
            attrs: {
              programInquiry: _vm.showProgramInquiry,
              guest: _vm.guest,
              child: _vm.child,
              errors: _vm.errors,
            },
            on: {
              submit: function ($event) {
                _vm.closeModal(() => (_vm.showProgramInquiry = false))
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.showProgramInquiry = false))
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }